module.exports = __webpack_public_path__ + "img/custom_targeting.4111d397.svg";